import { FC } from 'react';
import { Image, Text } from '@concepta/react-material-ui';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { FormContainer } from 'app/hooks/useGlobalForm';
import StrollerDescription from 'app/components/StrollerDescription';
import ColorDisclaimer from 'app/components/ColorDisclaimer';

interface Props {
  openAccessoriesDialog: () => void;
}

const StrollerDisplay: FC<Props> = ({ openAccessoriesDialog }) => {
  const { currentProduct } = FormContainer.useContainer();
  const product = currentProduct?.product;

  return (
    <>
      <Text fontSize={36} fontWeight={700} color="primary.darker">
        {product?.ProductName}
      </Text>
      <StrollerDescription product={product} />
      <Box width="100%" maxWidth="346px" maxHeight="346px" mt={5}>
        {product && (
          <Image
            onClick={openAccessoriesDialog}
            src={product?.productImages?.[0]?.URL || ''}
            alt="Stroller preview"
            sx={{ cursor: 'pointer' }}
            imgFluid
          />
        )}
      </Box>

      <ColorDisclaimer productId={product?.ProductID} />

      <Button
        variant="contained"
        sx={{
          mt: 5,
          width: {
            xs: '100%',
            lg: '387px',
          },
        }}
        onClick={openAccessoriesDialog}
        color="secondary"
      >
        Reserve This Item Now
      </Button>
    </>
  );
};

export default StrollerDisplay;
